import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@app/shared/button/button.component';
import { SettingsService } from '@app/settings.service';
import { AddressService, DictionaryService } from '@shared/services';
import { HomeCarouselComponent } from '@app/shared/home-carousel/home-carousel.component';
import { RealPropertyService } from '@modules/real-property-details';
import { REAL_PROPERTY_FILTER } from '@app/real-property-list-filter/models';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent, HomeCarouselComponent],
})
export class NavComponent {
  @Input() buttons: { text: string, icon: string }[] = [];
  @Input() isTablet: boolean;
  @Input() isMobile: boolean;
  @Input() buttonsPage: number;

  @Output() next: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _settingsService: SettingsService,
    private _dictService: DictionaryService,
    private _addressService: AddressService,
    private _realPropertyService: RealPropertyService,
  ) {}

  setFilerAndRedirect(item: any) {
    this._settingsService.clearFilter();
    switch (item.text) {
      case 'Студия':
        this._settingsService.updateFilters({ layout: true });
        this._settingsService.updateFiltersCount({ layout: true });
        this._realPropertyService.getRealPropertyCountDispatch({ atelier: true });
        break;
      case 'Черновой':
        this._dictService.updateCurrentHouseCondition([4]);
        this._settingsService.updateFiltersCount({ condition: 4 });
        this._realPropertyService.getRealPropertyCountDispatch({ housingConditionIds: [4] });
        break;
      case 'Дизайнерские':
        this._dictService.updateCurrentHouseCondition([3]);
        this._settingsService.updateFiltersCount({ condition: 3 });
        this._realPropertyService.getRealPropertyCountDispatch({ housingConditionIds: [3] });
        break;
      case 'Левый берег':
        // Есиль, Нура
        const districtIds = environment.production ? [173, 3746] : [173, 60048];
        this._addressService.updateCurrentDistricts(districtIds);
        this._settingsService.updateFiltersCount({ district: districtIds });
        this._realPropertyService.getRealPropertyCountDispatch({ addressCodes: ['001001010', '001001020'] });
        break;
      case 'Правый берег':
        // Алматы, Байконыр, Сарыарка
        this._addressService.updateCurrentDistricts([2, 121, 138]);
        this._settingsService.updateFiltersCount({ district: [2, 121, 138] });
        this._realPropertyService.getRealPropertyCountDispatch({ addressCodes: ['001001007', '001001002', '001001003'] });
        break;
      case 'Новинки':
        this._realPropertyService.getRealPropertyCountDispatch(REAL_PROPERTY_FILTER());
        break;
    }
    this.next.emit(item);
  }
}